import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { FileText, Download, Trash2 } from "lucide-react";

export default function DocumentCard({ document, onDelete }) {
  return (
    <Card className="border-none shadow-lg hover:shadow-xl transition-all">
      <CardContent className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center">
            <FileText className="w-6 h-6 text-white" />
          </div>
          <Badge className="bg-blue-100 text-blue-800">{document.category}</Badge>
        </div>
        
        <h3 className="text-lg font-bold text-gray-900 mb-2">{document.title}</h3>
        <p className="text-sm text-gray-600 mb-4 line-clamp-2">{document.description}</p>

        <div className="flex gap-2">
          <Button 
            size="sm" 
            variant="outline" 
            className="flex-1 gap-2"
            onClick={() => window.open(document.file_url, '_blank')}
          >
            <Download className="w-4 h-4" />
            Download
          </Button>
          <Button 
            size="sm" 
            variant="outline" 
            className="gap-2 text-red-600"
            onClick={() => onDelete(document.id)}
          >
            <Trash2 className="w-4 h-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
